var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(4.166666666666667,0,0,4.166666666666667,0,0)"},[React.createElement("path",{"d":"M23.5 0.499L9 18.499 4 13.499","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18.273,12.493A8.993,8.993,0,1,1,13.5,6.435","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

Check.defaultProps = {"version":"1.1","xmlnsSvgjs":"http://svgjs.com/svgjs","viewBox":"0 0 100 100","width":"100","height":"100"};

module.exports = Check;

Check.default = Check;
